import { useTranslation } from "react-i18next";

// ** Custom Components
import { ButtonSecondary } from "components/layout/Button/ButtonSecondary";
import Text from "components/typography/Text";

// ** SVG Static Imports
import { ReactComponent as SolidExchange } from "resources/icons/solid/exchange.svg";

// #####################################################

const ChangeFiltersButton = ({
	setFiltersOpen,
	filtersOpen,
	iconOnly = false,
}) => {
	const { t } = useTranslation(["common"]);

	// #####################################################

	return (
		<ButtonSecondary
			icon="change"
			svgIconComponent={SolidExchange}
			iconSize="0.85rem"
			onClick={() => {
				if (setFiltersOpen) {
					setFiltersOpen((prev) => !prev);
				}
			}}
			iconOnly={iconOnly}
		>
			<Text>{t("change")}</Text>
		</ButtonSecondary>
	);
};

// #####################################################

export default ChangeFiltersButton;

// #####################################################
